import { FormikProps } from 'formik';

export interface ExportsProps {
    readonly created_at: Date;
    readonly file_path: string;
    readonly id: number;
    readonly params: ExportsParams;
    readonly status: string;
    readonly type: ExportType;
}

export type ExportsParams = {
    readonly shop_id: number;
    readonly start_at: Date;
    readonly end_at: Date;
};

export interface ExportProps {
    shop_id: number;
    limit: number;
    offset: number;
    page: number;
}

export interface ExportFormValues {
    shop_id?: number;
    type?: string;
    start_at?: string;
    end_at?: string;
}

export interface ExportsFormProps {
    formik: FormikProps<ExportFormValues>;
}

export interface ExportsModalProps {
    createExport: () => Promise<void>;
    isSuccess: boolean;
    isLoading: boolean;
}

export const EXPORT_TYPES = {
    ORDERS: 'orders',
    VISITORS: 'visitors',
} as const;
export type ExportType = (typeof EXPORT_TYPES)[keyof typeof EXPORT_TYPES];
